import { useEffect, useState } from 'react';
import { AccessibleMenu } from './components/AccessibleMenu';
import { checkAppwriteConnection } from './services/appwrite/client';

type ConnectionStatus = 'checking' | 'ready' | 'unavailable';

export default function App() {
  const [announcement, setAnnouncement] = useState('');
  const [connectionStatus, setConnectionStatus] = useState<ConnectionStatus>('checking');

  useEffect(() => {
    let active = true;
    void checkAppwriteConnection().then((connected) => {
      if (active) setConnectionStatus(connected ? 'ready' : 'unavailable');
    });
    return () => {
      active = false;
    };
  }, []);

  const connectionMessage =
    connectionStatus === 'ready'
      ? 'La conexión del sitio está preparada.'
      : connectionStatus === 'unavailable'
        ? 'El sitio informativo sigue disponible mientras se prepara la conexión.'
        : 'Comprobando la conexión del sitio.';

  return (
    <div className="site-shell">
      <a className="visually-hidden-focusable skip-link" href="#main-content">
        Saltar al contenido principal
      </a>
      <AccessibleMenu onAnnounce={setAnnouncement} />

      <div className="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
        {announcement}
      </div>

      <main id="main-content" tabIndex={-1}>
        <section id="inicio" className="hero" aria-labelledby="hero-title">
          <div className="container hero-grid">
            <div className="hero-copy">
              <p className="eyebrow">Próximamente</p>
              <h1 id="hero-title">Orun</h1>
              <p className="hero-lead">Un nuevo proyecto está en camino.</p>
              <p className="hero-text">
                Estamos preparando este espacio. Aquí encontrará la información necesaria
                cuando Orun esté listo para presentarse.
              </p>
              <a className="primary-link" href="#proyecto">
                Conocer el estado del proyecto
              </a>
            </div>

            <div className="orun-mark" aria-hidden="true">
              <span className="orbit orbit-one" />
              <span className="orbit orbit-two" />
              <span className="orbit-core">O</span>
            </div>
          </div>
        </section>

        <section id="proyecto" className="project-section" aria-labelledby="project-title">
          <div className="container">
            <div className="project-card">
              <div>
                <p className="section-number" aria-hidden="true">01</p>
                <h2 id="project-title">Estamos preparando Orun</h2>
              </div>
              <div>
                <p>
                  El proyecto se encuentra en su etapa inicial. Todavía no publicaremos sus
                  detalles, pero este será su sitio oficial.
                </p>
                <p className="status-pill">
                  <span className="status-dot" aria-hidden="true" />
                  Estado: en preparación
                </p>
              </div>
            </div>
          </div>
        </section>

        <section
          id="accesibilidad"
          className="accessibility-section"
          aria-labelledby="accessibility-title"
        >
          <div className="container accessibility-grid">
            <div>
              <p className="section-number" aria-hidden="true">02</p>
              <h2 id="accessibility-title">Accesible desde el comienzo</h2>
            </div>
            <p>
              Orun se está construyendo para funcionar con teclado, lector de pantalla,
              ampliación y distintas preferencias visuales. Puede usar el botón
              “Accesibilidad” de la cabecera o el atajo Alt + A.
            </p>
          </div>
        </section>

        <p className="visually-hidden" role="status" aria-live="polite">
          {connectionMessage}
        </p>
      </main>

      <footer className="site-footer">
        <div className="container footer-content">
          <p className="footer-brand">Orun</p>
          <p>Desarrollada por Miguel Barraza.</p>
        </div>
      </footer>
    </div>
  );
}
